function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { forEach } from 'min-dash';
import { Base } from '../../model';
import AddRowHandler from './cmd/AddRowHandler';
import RemoveRowHandler from './cmd/RemoveRowHandler';
import MoveRowHandler from './cmd/MoveRowHandler';
import AddColHandler from './cmd/AddColHandler';
import RemoveColHandler from './cmd/RemoveColHandler';
import MoveColHandler from './cmd/MoveColHandler';
import EditCellHandler from './cmd/EditCellHandler';
/**
 * The basic modeling entry point.
 *
 * @param {EventBus} eventBus
 * @param {ElementFactory} elementFactory
 * @param {CommandStack} commandStack
 */

var Modeling =
/*#__PURE__*/
function () {
  function Modeling(eventBus, elementFactory, commandStack) {
    var _this = this;

    _classCallCheck(this, Modeling);

    this._eventBus = eventBus;
    this._elementFactory = elementFactory;
    this._commandStack = commandStack;
    eventBus.on('table.init', function () {
      // register modeling handlers
      registerHandlers(_this.getHandlers(), commandStack);
    });
  }

  _createClass(Modeling, [{
    key: "getHandlers",
    value: function getHandlers() {
      return Modeling._getHandlers();
    }
  }, {
    key: "_create",
    value: function _create(type, attrs) {
      if (attrs instanceof Base) {
        return attrs;
      } else {
        return this._elementFactory.create(type, attrs);
      }
    } // public API

  }, {
    key: "addRow",
    value: function addRow(attrs, index) {
      var row = this._create('row', attrs);

      var context = {
        row: row,
        index: index
      };

      this._commandStack.execute('row.add', context);

      return row;
    }
  }, {
    key: "removeRow",
    value: function removeRow(row) {
      this._commandStack.execute('row.remove', {
        row: row
      });
    }
  }, {
    key: "moveRow",
    value: function moveRow(row, index) {
      var context = {
        row: row,
        index: index
      };

      this._commandStack.execute('row.move', context);
    }
  }, {
    key: "addCol",
    value: function addCol(attrs, index) {
      var col = this._create('col', attrs);

      var context = {
        col: col,
        index: index
      };

      this._commandStack.execute('col.add', context);

      return col;
    }
  }, {
    key: "removeCol",
    value: function removeCol(col) {
      this._commandStack.execute('col.remove', {
        col: col
      });
    }
  }, {
    key: "moveCol",
    value: function moveCol(col, index) {
      var context = {
        col: col,
        index: index
      };

      this._commandStack.execute('col.move', context);
    }
  }, {
    key: "editCell",
    value: function editCell(cell, changedAttrs) {
      var context = _objectSpread({
        cell: cell
      }, changedAttrs);

      this._commandStack.execute('cell.edit', context);
    }
  }], [{
    key: "_getHandlers",
    value: function _getHandlers() {
      return {
        'row.add': AddRowHandler,
        'row.remove': RemoveRowHandler,
        'row.move': MoveRowHandler,
        'col.add': AddColHandler,
        'col.remove': RemoveColHandler,
        'col.move': MoveColHandler,
        'cell.edit': EditCellHandler
      };
    }
  }]);

  return Modeling;
}();

export { Modeling as default };
Modeling.$inject = ['eventBus', 'elementFactory', 'commandStack']; // helpers /////////////

/**
 * Register handlers with the command stack
 *
 * @param {Object} handlers { id -> Handler } map
 * @param {CommandStack} commandStack
 */

function registerHandlers(handlers, commandStack) {
  forEach(handlers, function (handler, id) {
    commandStack.registerHandler(id, handler);
  });
}
//# sourceMappingURL=Modeling.js.map